import { HasRole, useAccount } from "@qw/auth";
import {
  type BankanQuoteColumn,
  type MarketingPlanBankanColumn,
  Roles,
  useBankanMarketingPlanColumnQuery,
  useBankanQuoteColumnQuery,
} from "@qw/graphql";
import { AppNavLink, AppNavSection, columnMetadata } from "@qw/ui";
import { opportunityColumns, quoteColumns } from "@/constants/bankan-columns";

export const BankanLinks = () => (
  <HasRole roles={[Roles.Broker]}>
    <AppNavSection className="flex-auto empty:hidden">
      {opportunityColumns.map((column) => (
        <BankanCardOpportunities key={column} column={column} />
      ))}
      {quoteColumns.map((column) => (
        <BankanCardQuotes key={column} column={column} />
      ))}
    </AppNavSection>
  </HasRole>
);

const BankanCardOpportunities = ({ column }: { column: MarketingPlanBankanColumn }) => {
  const { user } = useAccount();

  const { data } = useBankanMarketingPlanColumnQuery({
    variables: {
      input: {
        brokerId: user.id,
        column,
      },
    },
    fetchPolicy: "cache-and-network",
  });

  const count = data?.bankanMarketingPlanColumn?.groupedMarketingPlans.length;

  const { icon, label } = columnMetadata(column);

  return <AppNavLink to={`/bankan/${column}`} icon={icon} label={label} count={count} />;
};

const BankanCardQuotes = ({ column }: { column: BankanQuoteColumn }) => {
  const { user } = useAccount();

  const { data } = useBankanQuoteColumnQuery({
    variables: {
      input: {
        brokerId: user.id,
        column,
      },
    },
    fetchPolicy: "cache-and-network",
  });

  const count = data?.bankanQuoteColumn?.groupedQuotes.length;

  if (!count) {
    return null;
  }

  const { icon, label } = columnMetadata(column);

  return <AppNavLink to={`/bankan/${column}`} icon={icon} label={label} count={count} />;
};
